import BuiApp from "./components/app"
import BuiAppBar from "./components/appbar"
import BuiIcon from "./components/icon"
import BuiNav from "./components/nav"
import BuiButton from "./components/button"
import BuiModal from "./components/modal"
import BuiDialog from "./components/dialog"
import BuiTreeView from "./components/treeview"
import BuiTreeNode from "./components/tree-node"
import BuiPopup from "./components/popup"
import BuiMenu from "./components/menu"
import BuiProgress from "./components/progress"
import BuiBadge from "./components/badge"
import Ripple from "./components/ripple"
import MessageBox from "./components/message-box"
import BuiTabs from "./components/tabs"
import BuiTab from "./components/tab"
import BuiGrid from "./components/grid"
import Tooltip from "./components/tooltip"
import BuiCalendar from "./components/calendar"
import Ajax from "./components/ajax"
import FormErrorBinder from "./components/errorbinder/form-errorbinder"
import * as Utils from "./components/utils"
import BuiSplitter from "./components/splitter"

// API
window.bui = window.bui || {}
window.bui.Ripple = Ripple
window.bui.MessageBox = new MessageBox()
window.bui.Tooltip = new Tooltip()
window.bui.Ajax = Ajax
window.bui.FormErrorBinder = FormErrorBinder
window.bui.Utils = Utils

// CustomComponents
customElements.define("bui-app", BuiApp)
customElements.define("bui-appbar", BuiAppBar)
customElements.define("bui-icon", BuiIcon)
customElements.define("bui-button", BuiButton, { extends: "button" })
customElements.define("bui-nav", BuiNav)
customElements.define("bui-modal", BuiModal)
customElements.define("bui-dialog", BuiDialog)
customElements.define("bui-treeview", BuiTreeView)
customElements.define("bui-tree-node", BuiTreeNode)
customElements.define("bui-popup", BuiPopup)
customElements.define("bui-menu", BuiMenu)
customElements.define("bui-progress", BuiProgress)
customElements.define("bui-badge", BuiBadge)
customElements.define("bui-tabs", BuiTabs)
customElements.define("bui-tab", BuiTab)
customElements.define("bui-grid", BuiGrid)
customElements.define("bui-calendar", BuiCalendar)
customElements.define("bui-splitter", BuiSplitter)
